export const importAllFiles = (r: any) => {
  return r.keys().map(r);
};
